import type { TaskSummary } from "../domain/entities";

export interface TaskFacts {
  status: string;
  location: string;
  start: string;
  deadline: string;
  nextAction: string;
}

export function taskFacts(task: TaskSummary): TaskFacts {
  const status = task.status === "completed" ? "Completed" : task.status === "cancelled" ? "Cancelled" : "Open";
  const location = task.project
    ? `${task.project.name}${task.heading ? ` / ${task.heading.title}` : ""}`
    : task.area?.name ?? "None";
  const schedule = ({ inbox: "Inbox", anytime: "Anytime", today: "Today", date: "Pick a Date", someday: "Someday" } as Record<string, string>)[task.scheduleKind] ?? task.scheduleKind;
  const start = task.startDate ? `${schedule} · ${task.startDate}` : schedule;
  return {
    status,
    location,
    start,
    deadline: task.deadline ?? "No Deadline",
    nextAction: task.status === "open" ? "Complete the Task or update its plan" : "Restore the Task to continue",
  };
}
